function checkout() {
    const checkoutBtn = document.querySelector('button[name="checkout"], #checkout, .checkout-btn');
    console.log(checkoutBtn)

    if (checkoutBtn) {
        checkoutBtn.addEventListener("click", (e) => {
            if (checkoutBtn.disabled) {
                e.preventDefault();
                return false;
            }

            // Khóa nút lại
            checkoutBtn.disabled = true;
            checkoutBtn.style.opacity = "0.6";
            checkoutBtn.style.cursor = "not-allowed";
            checkoutBtn.classList.add('bss-disable')

            // Nếu cần submit form hoặc chuyển trang
            setTimeout(() => {
                checkoutBtn.disabled = false;
                checkoutBtn.style.opacity = "1";
                checkoutBtn.style.cursor = "pointer";
                checkoutBtn.style.pointerEvents = "auto"; // chặn mọi click
                checkoutBtn.classList.remove('bss-disable')
            }, 5000); // sau 5s mới cho bấm lại
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    checkout()
    let quickAddDrawer1 = document.querySelector('.cart-container')

    if (quickAddDrawer1) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                if (m.addedNodes.length) {
                    setTimeout(() => {
                        checkout()
                        BSS_B2B.observer.cartSubject.listenCartCheckout()
                    }, 2000);
                }
            });
        });
        observer.observe(quickAddDrawer1, {
            childList: true
        });
    }
    let quickAddDrawer = document.querySelector('cart-drawer')

    if (quickAddDrawer) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                if (m.addedNodes.length) {
                    setTimeout(() => {
                        checkout()
                        BSS_B2B.observer.cartSubject.listenCartCheckout()
                        let quickAddDrawer1 = document.querySelector('.drawer__inner')

                        if (quickAddDrawer1) {
                            let observer = new MutationObserver(function(mutations) {
                                mutations.forEach(function(m) {
                                    if (m.addedNodes.length) {
                                        setTimeout(() => {
                                            checkout()
                                            BSS_B2B.observer.cartSubject.listenCartCheckout()
                                        }, 2000);
                                    }
                                });
                            });
                            observer.observe(quickAddDrawer1, {
                                childList: true
                            });
                        }


                    }, 2000);
                }
            });
        });
        observer.observe(quickAddDrawer, {
            childList: true
        });
    }
    let buttonAtc = document.querySelectorAll('.quick-add__submit ,.product-form__submit')
    if (buttonAtc.length) {
        buttonAtc.forEach(element => {
            element.addEventListener('click', ()=>{
                setTimeout(() => {
                     BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
                    BSS_B2B.observer.cartSubject.listenCartCheckout()
                
                }, 2000 );
            })
        });
    }
});